const BASE = 'https://os.studio-soma.de/api';

export const apiFetch = async (pfad, optionen = {}) => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    ...(optionen.headers || {})
  };
  const res = await fetch(`${BASE}${pfad}`, { ...optionen, headers });
  if (res.status === 401) {
    localStorage.removeItem('token');
    window.location.reload();
    return;
  }
  return res;
};